import { render, staticRenderFns } from "./RelatorioComprasCashPosto.vue?vue&type=template&id=1abfcb18&"
import script from "./RelatorioComprasCashPosto.vue?vue&type=script&lang=js&"
export * from "./RelatorioComprasCashPosto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports